<template>
  <header class="header">
    <div class="header__wrapper">
      <h2 class="header-title">
        <div class="header-home-icon">
          <img src="/app/assets/img/home-icon.svg" @click="onClickHomeIcon" />
        </div>
        <slot name="title"></slot>
      </h2>
      <nav class="header-menu">
        <slot name="menu"></slot>
      </nav>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Header",
  components: {},
  props: {},
  setup() {
    const router = useRouter();
    const toTop = () => router.push({ name: "top" });

    function onClickHomeIcon() {
      if (confirm("編集を破棄してホーム画面に戻りますか？")) {
        toTop();
        return;
      } else {
        return;
      }
    }

    return {
      onClickHomeIcon,
    };
  },
});
</script>

<style scoped>
.header {
  font-family: "Sawarabi Mincho", sans-serif;
}
.header__wrapper {
  display: flex;
  flex-flow: column;
}
.header-home-icon {
  width: 4rem;
  position: absolute;
  left: 20px;
  top: 0.8rem;
}
.header-title {
  font-size: 4rem;
  color: #ebf6f7;
  text-align: center;
  text-shadow: 2px 2px 4px #666666;
  background: linear-gradient(#e6b422, #f9c89b);
  height: 70px;
}
.header-menu {
  background: linear-gradient(#524e4d, #71686c);
  padding: 1.5rem 0;
  height: 130px;
}
</style>
